<template>
  <div>
    <MenuNavbar type="vertical">
      <MenuLinkItem
        v-if="!hasUserSubscriptionAccess"
        :to="{ name: 'subscribe' }"
      >Conquiste seus sonhos!</MenuLinkItem>

      <MenuLinkItem :to="{ name: 'user.account', params: {tab:'plano'} }">
        Minha conta
      </MenuLinkItem>

      <MenuLinkItem :to="{ name: 'user.profile', params: {slug: user.slug} }">
        Meu perfil
      </MenuLinkItem>

      <MenuSidebarItem name="UserPlaylistDefaultSidebar">
        Favoritos
      </MenuSidebarItem>

      <MenuSidebarItem name="CoursesCompletedSidebar" size="full">
        Histórico de cursos
      </MenuSidebarItem>

      <MenuLinkItem :to="{ name: 'support' }">
        Suporte
      </MenuLinkItem>
      
      <MenuItem @click="logout">
        Sair
      </MenuItem>
    </MenuNavbar>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import MenuNavbar from '@/components/menu/MenuNavbar'
  import MenuLinkItem from '@/components/menu/MenuLinkItem'
  import MenuSidebarItem from '@/components/menu/MenuSidebarItem'
  import MenuItem from '@/components/menu/MenuItem'

  export default {
    components: {
      MenuNavbar,
      MenuLinkItem,
      MenuSidebarItem,
      MenuItem,
    },
    
    computed: {
      ...mapGetters('user', [
        'user',
        'hasUserSubscriptionAccess'
      ])
    },

    methods: {
      logout () {
        this.$store.dispatch('auth/logout')
      },
    }
  }
</script>